import Keycloak from 'keycloak-js'

var installed = false

export default {
  install: (Vue, params = {}) => {
    if (installed) return
    installed = true

    const defaultParams = {
      config: window.__BASEURL__ ? `${window.__BASEURL__}/config` : '/config',
      init: { onLoad: 'login-required' }
    }
    const options = Object.assign({}, defaultParams, params)
    if (assertOptions(options).hasError) throw new Error(`Invalid options given: ${assertOptions(options).error}`)

    const watch = Vue.observable({
      ready: false,
      authenticated: false,
      token: null,
      logout: null,
      login: null,
      idTokenParsed: null,
      resourceAccess: null,
      refreshToken: null
    })
    Object.defineProperty(Vue.prototype, '$keycloak', {
      get() {
        return watch
      }
    })
    getConfig(options.config)
      .then(config => {
        init(config, watch, options)
      })
      .catch(error => {
        console.error(error)
      })
  }
}

function init(config, watch, options) {
  const keycloak = Keycloak(config)

  keycloak.onReady = (authenticated) => {
    updateWatchVariables(authenticated)
    watch.ready = true
    typeof options.onReady === 'function' && options.onReady(keycloak)
  }
  keycloak.onAuthSuccess = () => {
    // Check token validity every 60 seconds (60000 ms) and, if necessary, update the token.
    // Refresh token if it's valid for less then 70 seconds
    const updateTokenInterval = setInterval(() => keycloak.updateToken(70).catch(() => {
      keycloak.clearToken()
    }), 60000)
    watch.logout = () => {
      clearInterval(updateTokenInterval)
      keycloak.logout({ 'redirectUri': process.env.VUE_APP_ICIRED_BASE_URL })
    }
  }
  keycloak.onAuthRefreshSuccess = () => {
    updateWatchVariables(true)
  }
  keycloak.onAuthRefreshError = () => {
    updateWatchVariables(false)
    typeof options.onAuthRefreshError === 'function' && options.onAuthRefreshError(keycloak)
  }
  keycloak.init(options.init).then((authenticated) => {
    updateWatchVariables(authenticated)
    typeof options.onInitSuccess === 'function' && options.onInitSuccess(authenticated)
  }).catch((err) => {

    updateWatchVariables(false)
    const error = Error('Could not initialized keycloak-js adapter')
    typeof options.onInitError === 'function' ? options.onInitError(error, err) : console.error(error, err);
    keycloak.logout();
  })

  function updateWatchVariables(isAuthenticated = false) {
    watch.authenticated = isAuthenticated
    watch.login = keycloak.login

    if (isAuthenticated) {
      watch.token = keycloak.token
      watch.idTokenParsed = keycloak.idTokenParsed
      watch.resourceAccess = keycloak.resourceAccess
      watch.refreshToken = keycloak.refreshToken
    }
  }
}

function assertOptions(options) {
  const { config, init, onReady, onInitError, onAuthRefreshError } = options
  if (typeof config !== 'string' && !_isObject(config)) {
    return { hasError: true, error: `'config' option must be a string or an object. Found: '${config}'` }
  }
  if (!_isObject(init) || typeof init.onLoad !== 'string') {
    return { hasError: true, error: `'init' option must be an object with an 'onLoad' property. Found: '${init}'` }
  }
  if (onReady && typeof onReady !== 'function') {
    return { hasError: true, error: `'onReady' option must be a function. Found: '${onReady}'` }
  }
  if (onInitError && typeof onInitError !== 'function') {
    return { hasError: true, error: `'onInitError' option must be a function. Found: '${onInitError}'` }
  }
  if (onAuthRefreshError && typeof onAuthRefreshError !== 'function') {
    return { hasError: true, error: `'onAuthRefreshError' option must be a function. Found: '${onAuthRefreshError}'` }
  }
  return {
    hasError: false,
    error: null
  }
}

function _isObject(obj) {
  return obj !== null && typeof obj === 'object' && Object.prototype.toString.call(obj) !== '[object Array]'
}

function getConfig(config) {
  if (_isObject(config)) return Promise.resolve(config)

  throw new Error(`Invalid config given`)
}